import { RECHFORM_TYPE_SELF_EMPLOYED_PERSON } from "../constants/VollmachtsDatenBankConstants";

/**
 * Checks if the halter form represents a self-employed individual (Einzelunternehmen/Selbstständige)
 *
 * @param {Object} halterFormValues - Halter form values containing rechtsform and other fields
 * @param {Array} rechtsformData - Structured rechtsform data from backend
 * @param {boolean} isPPOA - If true, only checks rechtsform without address requirement
 * @returns {boolean} True if self-employed person condition is met
 */
export const isSelfEmployedIndividualAddress = (
  halterFormValues,
  rechtsformData,
  isPPOA = false
) => {
  const rechtsform = isPPOA
    ? halterFormValues?.rechtsform
    : halterFormValues?.rechtsform?.value?.subHeader ||
      halterFormValues?.rechtsform?.value;

  const category = isPPOA
    ? halterFormValues?.rechtsformCategory
    : halterFormValues?.rechtsformCategory?.value;

  if (
    !isPPOA &&
    halterFormValues?.halterAddress?.value !== "individuelleAddresse"
  ) {
    return false;
  }

  return Boolean(
    category === RECHFORM_TYPE_SELF_EMPLOYED_PERSON ||
      rechtsform === RECHFORM_TYPE_SELF_EMPLOYED_PERSON ||
      rechtsformData?.some(
        (group) =>
          group.header === RECHFORM_TYPE_SELF_EMPLOYED_PERSON &&
          group.subHeaders?.includes(rechtsform)
      )
  );
};
